<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <v-app>
                        <v-container fluid>
                            <v-card elevation="2" outlined>
                                <v-card-title>
                                    <!--v-if="$can('role_create')"-->
                                    <v-btn to="/categories/create" rounded color="#308BB0" class="text-white">
                                        <v-icon>mdi-plus</v-icon>
                                        افزودن دسته بندی
                                    </v-btn>
                                    <v-spacer/>
                                    Edit Page
                                    <v-spacer/>
<!--                                    <v-btn :loading="loading" @click="this.fetchIndexData" color="primary" rounded-->
<!--                                           class="text-white">-->
<!--                                        <v-icon>mdi-refresh</v-icon>-->
<!--                                        به روزرسانی-->
<!--                                    </v-btn>-->

                                </v-card-title>

                                    <v-container fluid>
                                            <v-layout row wrap>

                                                <v-flex xs12 sm6 md4 class="mr-1 ml-1">
                                                    <v-text-field
                                                        label="نام"
                                                        required=""
                                                        v-model="permissionData.name"
                                                        outlined
                                                        :desabled="true"
                                                        dense
                                                        class="mt-3"
                                                    ></v-text-field>
                                                </v-flex>


                                                <v-flex xs12 sm6 md4 class="mr-1 ml-1">
                                                    <v-text-field
                                                        label="نام فارسی"
                                                        v-model="permissionData.name_fa"
                                                        outlined
                                                        dense
                                                        :desabled="true"
                                                        class="mt-3"
                                                    ></v-text-field>
                                                </v-flex>

                                        <v-flex xs12 sm6 md4 class="mr-1 ml-1">
                                            <v-text-field
                                                label="دسته بندی والد"
                                                outlined
                                                dense
                                                class="mt-3"
                                            ></v-text-field>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>

                                <v-divider/>
                            </v-card>


                        </v-container>

                        <!--            Add New Button And Refresh-->


                        <!--                    <div class="card-body">-->
                        <!--                        <router-link-->
                        <!--                            class="btn btn-primary"-->
                        <!--                            v-if="$can(xprops.permission_prefix + 'create')"-->
                        <!--                            :to="{ name: xprops.route + '.create' }"-->
                        <!--                        >-->
                        <!--                            <i class="material-icons">-->
                        <!--                                add-->
                        <!--                            </i>-->
                        <!--                            {{ $t('global.add') }}-->
                        <!--                        </router-link>-->


                        <!--                        &lt;!&ndash;              Refresh Button&ndash;&gt;-->
                        <!--                        <button-->
                        <!--                            type="button"-->
                        <!--                            class="btn btn-default"-->
                        <!--                            @click="fetchIndexData"-->
                        <!--                            :disabled="loading"-->
                        <!--                            :class="{ disabled: loading }"-->
                        <!--                        >-->
                        <!--                            <i class="material-icons" :class="{ 'fa-spin': loading }">-->
                        <!--                                refresh-->
                        <!--                            </i>-->
                        <!--                            {{ $t('global.refresh') }}-->
                        <!--                        </button>-->
                        <!--                    </div>-->


                    </v-app>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import DatatableActions from "../../content/Datatables/DatatableActions";
import GlobalSearch from "../../content/Datatables/GlobalSearch";

export default {
    components: {
        GlobalSearch,
    },
    props: ['id'],

    data() {
        return {
            permissionData: {name: '', name_fa: '', type: ''},
            columns: [
                {
                    title: 'شناسه',
                    field: 'id',
                    sortable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    title: 'عنوان',
                    field: 'name',
                    sortable: true
                },
                {
                    title: 'عملیات',
                    tdComp: DatatableActions,
                    visible: true,
                    thClass: 'text-right',
                    tdClass: 'text-right td-actions',
                    colStyle: 'width: 150px;'
                }
            ],
            query: {sort: 'id', order: 'desc', limit: 100, s: ''},
            xprops: {
                module: 'PermissionsIndex',
                route: 'permission',
                permission_prefix: 'permission_'
            }
        }
    },
    beforeDestroy() {
        this.resetState()
    },
    computed: {
        ...mapGetters(["layoutConfig"]),
        ...mapGetters('PermissionsIndex', ['data', 'total', 'loading']),

        config() {
            return this.layoutConfig();
        }
    },
    watch: {
        query: {
            handler(query) {
                this.setQuery(query)
                this.fetchIndexData()
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('PermissionsIndex', [
            'fetchIndexData',
            'setQuery',
            'resetState'
        ]),
        showPermission(id) {
            this.requestApiGet(`permission/${id}`)
                .then(({data}) => {
                    this.permissionData = data.data;


                })
        },
    },
    mounted() {
        this.showPermission(this.id);


    }
}
</script>
